import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hotspot-scene__caption"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "hotspot-scene__wrap" }
const _hoisted_5 = { class: "hotspot-scene__image-container" }
const _hoisted_6 = { class: "hotspot-scene__image-wrap" }
const _hoisted_7 = ["src"]

import { computed, ref, watch } from 'vue';

import Hotspot from 'Vue/components/hotspotComponents/Hotspot.vue';
import { HotspotPlacement } from 'Interfaces/interfaces';
const componentName = 'HotspotScene';

export default /*#__PURE__*/_defineComponent({
  __name: 'HotspotScene',
  props: {
	backgroundImage: {
		type: String,
		default: ''
	},
	caption: {
		type: String,
		default: ''
	},
	captionTitle: {
		type: String,
		default: ''
	},
	displayTitle: {
		type: String,
		default: ''
	},
	activeIndex: {
		type: Number,
		default: 0
	},
	hotspotPlacements: {
		type: Array as () => HotspotPlacement[],
		default: []
	},
	title: {
		type: String,
		default: ''
	},
	modalVisible: {
		type: Boolean,
		default: false
	},
	id: {
		type: String,
		default: ''
	},
	sceneAssociatedColor: {
		type: String,
		default: ''
	}
},
  emits: ['modalVisibilityUpdated','updateActiveHotspotIndex'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const activeHotspotIndex = ref<number>(0);
const primaryImage = ref(null);
const props = __props;


const hotspotPlacements = computed(() => {
	let hotspotsArray = [];
	props.hotspotPlacements.forEach((hotspotPlacement) => {
		hotspotsArray.push(hotspotPlacement);
	})

	return hotspotsArray;
});

watch(() => props.activeIndex, (newValue) => {
	primaryImage.value.classList.remove('animate__fadeInRight');
	primaryImage.value.classList.add('animate__fadeInRight');
});


const updateActiveHotspotIndex = (indexValue) => {
	emit('updateActiveHotspotIndex', indexValue);
}

const openFirstHotspot = () => {
	emit('updateActiveHotspotIndex', 0);
	emit('modalVisibilityUpdated', true);
}

const modalVisibilityUpdated = (value) => {
	emit('modalVisibilityUpdated', value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.captionTitle || __props.caption)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (__props.captionTitle)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "hotspot-scene__caption-title",
                innerHTML: __props.captionTitle
              }, null, 8 /* PROPS */, _hoisted_2))
            : _createCommentVNode("v-if", true),
          (__props.caption)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "hotspot-scene__caption-body",
                innerHTML: __props.caption
              }, null, 8 /* PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: __props.backgroundImage,
            alt: "scene background",
            class: "hotspot-scene__image animate__animated",
            ref_key: "primaryImage",
            ref: primaryImage,
            onClick: openFirstHotspot
          }, null, 8 /* PROPS */, _hoisted_7),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hotspotPlacements.value, (hotspot, index) => {
            return (_openBlock(), _createBlock(Hotspot, {
              key: hotspot.Title,
              topPositionY: hotspot.TopPosition,
              leftPositionX: hotspot.LeftPosition,
              index: index,
              displayTitle: __props.displayTitle,
              modalVisible: __props.modalVisible,
              hotspotPlacementsLength: hotspotPlacements.value?.length,
              color: hotspot.HotspotColorOverride ? hotspot.HotspotColorOverride : __props.sceneAssociatedColor,
              onModalVisibilityUpdated: modalVisibilityUpdated,
              onUpdateActiveHotspotIndex: updateActiveHotspotIndex,
              hotspots: hotspot.SelectHotspot
            }, null, 8 /* PROPS */, ["topPositionY", "leftPositionX", "index", "displayTitle", "modalVisible", "hotspotPlacementsLength", "color", "hotspots"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})